module.exports = __webpack_public_path__ + "static/media/bad_score.dc5fa8c3.svg";